module.exports = __webpack_public_path__ + "fonts/HalisR-S-Black.8aefae04.otf";